export const CRUD_ENTITIES = {
  USER: {
    namespace: 'user',
  },
  STATUS_CATEGORY: {
    namespace: 'statusCategory',
  },
  PAGE: {
    namespace: 'page',
  },
  ANCILLARY_SERVICE: {
    namespace: 'ancillaryService',
  },
  VENUE: {
    namespace: 'venue',
  },
  ANCILLARY_SERVICE_REVIEW: {
    namespace: 'ancillaryServiceReview',
  },

  VENUE_REVIEW: {
    namespace: 'venueReview',
  },
  VENUE_RECOMMEND: {
    namespace: 'venueRecommend',
  },




};
